import React, { useState, useEffect, useRef } from "react";
import { Grid, Modal, Box, IconButton, TextField } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ErrorIcon from "@mui/icons-material/Error";
import CardAmostra from "./CardAmostra";
import "./styles.css";

export default function ConteudoMapa({ cards = [], loading = false, onConfirmarRemocao }) {
  const [tempoAgora, setTempoAgora] = useState(() => new Date());
  const [modalRemoverOpen, setModalRemoverOpen] = useState(false);
  const [amostraRemover, setAmostraRemover] = useState(null);
  const [biomeriuexBipado, setBiomeriuexBipado] = useState("");
  const [erroConferencia, setErroConferencia] = useState(false);
  const [processandoRemocao, setProcessandoRemocao] = useState(false);
  const inputRemocaoRef = useRef(null);

  useEffect(() => {
    const interval = setInterval(() => setTempoAgora(new Date()), 30000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (modalRemoverOpen && inputRemocaoRef.current) {
      const t = setTimeout(() => inputRemocaoRef.current?.focus(), 150);
      return () => clearTimeout(t);
    }
  }, [modalRemoverOpen]);

  function handleAbrirModalRemover(amostra) {
    setAmostraRemover(amostra);
    setBiomeriuexBipado("");
    setErroConferencia(false);
    setModalRemoverOpen(true);
  }

  function handleFecharModalRemover() {
    setModalRemoverOpen(false);
    setAmostraRemover(null);
    setBiomeriuexBipado("");
    setErroConferencia(false);
    setProcessandoRemocao(false);
  }

  async function handleKeyDownRemocao(e) {
    if (e.key !== "Enter") return;
    e.preventDefault();

    if (processandoRemocao || !amostraRemover || !biomeriuexBipado.trim()) return;

    const digitado = biomeriuexBipado.trim().toUpperCase();
    setErroConferencia(false);
    setProcessandoRemocao(true);
    try {
      await onConfirmarRemocao(amostraRemover.id, digitado);
      handleFecharModalRemover();
    } catch {
      setErroConferencia(true);
    } finally {
      setProcessandoRemocao(false);
    }
  }

  return (
    <div className="conteudo-mapa-trace">
      {loading && <div className="mensagem-vazia">Carregando cards...</div>}
      {!loading && cards.length === 0 && (
        <div className="mensagem-vazia">
          Nenhum card encontrado para os filtros selecionados.
        </div>
      )}
      <Grid container spacing={2}>
        {!loading && cards.map((amostra) => (
          <Grid item key={amostra.id} lg={2} md={3} sm={4} xs={12} className="conteiner-card-amostra">
            <CardAmostra
              amostra={amostra}
              tempoAgora={tempoAgora}
              onRemoverClick={handleAbrirModalRemover}
            />
          </Grid>
        ))}
      </Grid>
      <p className="conteudo-mapa-trace-aviso">
        Verde: recém colocado no banho. Laranja: faltam menos de 5 min para remover.
        Vermelho: hora de remover. Clique no card laranja ou vermelho para confirmar remoção.
      </p>

      <Modal
        open={modalRemoverOpen}
        onClose={handleFecharModalRemover}
        aria-labelledby="modal-remover-banho-title"
      >
        <Box className="modal-remover-banho">
          <h2 className="modal-remover-banho-title" id="modal-remover-banho-title">
            Remover do banho
            <IconButton
              aria-label="Fechar"
              onClick={handleFecharModalRemover}
              sx={{ float: "right", marginTop: "-8px" }}
            >
              <CloseIcon />
            </IconButton>
          </h2>
          {amostraRemover && (
            <>
              <p className="modal-remover-banho-tubo-esperado">
                <strong>Código da amostra esperado:</strong> {amostraRemover.biomeriuex || "—"}
                <br />
                Escaneie o mesmo código da amostra para confirmar a remoção.
              </p>
              <TextField
                inputRef={inputRemocaoRef}
                label={processandoRemocao ? "Confirmando..." : "Código da amostra"}
                value={biomeriuexBipado}
                onChange={(e) => {
                  setBiomeriuexBipado(e.target.value);
                  setErroConferencia(false);
                }}
                onKeyDown={handleKeyDownRemocao}
                variant="outlined"
                fullWidth
                autoComplete="off"
                disabled={processandoRemocao}
                className="modal-remover-banho-input"
              />
              {erroConferencia && (
                <div className="modal-remover-banho-feedback modal-remover-banho-feedback--erro">
                  <ErrorIcon /> Não confere com este tubo. Verifique o código da amostra escaneado.
                </div>
              )}
            </>
          )}
        </Box>
      </Modal>
    </div>
  );
}
